"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addIndexs = void 0;
const cloneDeep = require("lodash/cloneDeep");
const map = require("lodash/map");
const addIndexs = (items) => {
    let i = 0;
    let numberOfItems = map(items).length;
    return map(cloneDeep(items), (item) => {
        i = i + 1;
        return Object.assign(Object.assign({}, item), { numbericalIndex: i, isLast: numberOfItems === i, isFirst: i === 1, isOdd: i % 2 === 0 });
    });
};
exports.addIndexs = addIndexs;
//# sourceMappingURL=addIndexs.js.map